import { createSlice } from "@reduxjs/toolkit";
import { createApiThunk, updateState } from "../utilityFunction"

// Async Thunk for Fetching Setting Data
export const fetchEnquiryData = createApiThunk("feedback", "fetch")
export const saveEnquiryData = createApiThunk("feedback", "save")

let initState = {
    popup: {
        isOpen: false
    },
    sidebar: {
        isOpen: false
    },
    saveEnquiry: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null
    },
    fetchEnquiry: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null
    }
}

const enquirySlice = createSlice({
    name: "enquirySlice",
    initialState: initState,
    reducers: {
        handlePopup: (state, action) => {
            state.popup = {
                ...state.popup,
                isOpen: action.payload
            }
        },
        handleSidebar: (state, action) => {
            state.sidebar = {
                ...state.sidebar,
                isOpen: action.payload
            }
        },
        resetEnquiryState: (state, action) => {
            const type = action.payload; // Assuming the type is passed in the action's payload

            if (type === "fetch") {
                state.fetchEnquiry = {
                    ...state.fetchEnquiry, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            } else if (type === "save") {
                state.saveEnquiry = {
                    ...state.saveEnquiry, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            }
        },
    },
    extraReducers: (builder) => {
            builder
                .addCase(fetchEnquiryData.pending, (state) => updateState(state, "pending", "fetchEnquiry"))
                .addCase(fetchEnquiryData.fulfilled, (state, action) =>
                    updateState(state, "fulfilled", "fetchEnquiry", action.payload.data))
                .addCase(fetchEnquiryData.rejected, (state, action) =>
                    updateState(state, "rejected", "fetchEnquiry", action.payload))
                // Save data
                .addCase(saveEnquiryData.pending, (state) => updateState(state, "pending", "saveEnquiry"))
                .addCase(saveEnquiryData.fulfilled, (state, action) =>
                    updateState(state, "fulfilled", "saveEnquiry", action.payload.data))
                .addCase(saveEnquiryData.rejected, (state, action) =>
                    updateState(state, "rejected", "saveEnquiry", action.payload));
        },
})

export const { handlePopup, handleSidebar, resetEnquiryState } = enquirySlice.actions;
export default enquirySlice.reducer;